// extracted by mini-css-extract-plugin
export default {"html-text":"html-text__3Brli","fade-in":"fade-in__1u_dK","fade-out":"fade-out__tottw"};